import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { ApprovalCaseDetail } from '~/types/approvalCase';
import { AsideBase } from '~/layout';
import { ApprovalProgress } from './ApprovalProgress';
import { ApprovalActions } from './ApprovalActions';

interface Props {
  record: ApprovalCaseDetail;
  resource?: string;
  onActionEnd?: () => Promise<void>;
}

const ApprovalFlow = ({ record, resource, onActionEnd }: Props) => {
  const classes = useStyles();

  return (
    <AsideBase className={classes.aside}>
      <ApprovalProgress record={record} resource={resource} />
      <ApprovalActions record={record} resource={resource} onActionEnd={onActionEnd} />
    </AsideBase>
  );
};

const useStyles = makeStyles({
  aside: {
    flexDirection: 'column',
  },
});

export default ApprovalFlow;
